import { useRef, useState } from 'react'
import {
	ExampleEyeIcon,
	LeftArrowIcon,
	PostsSizeIcon,
	RightArrowIcon,
	StorySizeIcon,
	ActivePostIcon,
	UnActivePostIcon,
	UnActiveStoryIcon,
	ActiveStoryIcon,
} from '../icons'

//redux
import { useSelector } from 'react-redux'
import { RootState } from '../store/rootReducer'
import { useUtilActions } from '../store/util/action'

//use history
import { useHistory } from 'react-router-dom'

export const CreativeFormPost: React.FC = () => {
	//global State
	const isPost = useSelector((state: RootState) => state.util.isPost)

	const { setIsPost } = useUtilActions()

	//history hook
	const { push } = useHistory()

	//on post click
	const handleClickOnPost = () => {
		setIsPost(true)
	}

	const handleClickOnStory = () => {
		setIsPost(false)
	}

	return (
		<div className='creative-form-post'>
			<h5>ADYOUNEED Branding</h5>
			<h1>Creative Formate</h1>
			<p style={{ color: '#3b2a82' }}>
				Select your creative format below. For social media posts and ads use
				“1080x1080” and for story ads “1080x1920”. More creatives formats are on
				the way.
			</p>
			<section className='cards-grid'>
				<section
					className='post-size'
					onClick={() => handleClickOnPost()}
					style={{
						backgroundImage: isPost
							? 'linear-gradient(to bottom right, #ff3067, #ff6652)'
							: '',
						border: isPost ? '1px solid #ffffff' : '1px solid #f7f6fb',
						color: isPost ? '#ffffff' : '#3b2a82',
					}}>
					{!isPost ? <ActivePostIcon /> : <UnActivePostIcon />}
					<section className='content'>
						<h4>
							Post Size <b>(1080x1080)</b>
						</h4>
						<p>
							Perfect for social media feed posts and ads, one of the most
							popular creative formats.
						</p>
					</section>
				</section>
				<section className='example'>
					<section className='top-area'>
						<ExampleEyeIcon />
						<h4>Example</h4>
						<p>
							An example of how your creative will look like after our A.I.
							generates your creatives.
						</p>
					</section>
					<p>
						In the next step, you will see a preview based on your data and
						selections.
					</p>
				</section>
				<section
					className='story-size'
					onClick={() => handleClickOnStory()}
					style={{
						backgroundImage: isPost
							? ''
							: 'linear-gradient(to bottom right, #ff3067, #ff6652)',
						border: isPost ? '1px solid #f7f6fb' : '1px solid #ffffff',
						color: isPost ? '#3b2a82' : '#ffffff',
					}}>
					{!isPost ? <UnActiveStoryIcon /> : <ActiveStoryIcon />}
					<section className='content'>
						<h4>
							Story Size <b>(1080x1080)</b>
						</h4>
						<p>
							Perfect for vertical Story ads, the most used and recommended
							vertical creative format.
						</p>
					</section>
				</section>
			</section>
			<section className='buttons-section'>
				<section className='back-button-section'>
					<button>
						<LeftArrowIcon />
						Go Back
					</button>
				</section>
				<section className='continue-button-section'>
					<button onClick={() => push('/textandbuttonpost')}>
						Save & Continue <RightArrowIcon />
					</button>
				</section>
			</section>
		</div>
	)
}
